import dayjs from 'dayjs'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import ActiveFilters from '../../../../components/ActiveFilters/ActiveFilters'
import CheckBlock from '../../../../components/Forms/CheckBlock/CheckBlock'
import Preloader from '../../../../components/loaders/preloader/preloader'
import PhoneCallHelp from '../../../../components/popin/help/phoneCall'
import MessagePopin from '../../../../components/popin/MessagePopin/MessagePopin.jsx'
import {
    useSchoolTrainingCurrent,
    useSchoolTrainingFilters,
    useSchoolTrainingTunnel,
} from '../../../../components/SchoolTrainingSubscriptionContext/SchoolTrainingSubscriptionContext'
import Step from '../../../../components/stepsManagement/Step'
import { getKidsStages } from '../../../../globalAPI/api'
import useQueryParametersObject from '../../../../hooks/routing/useQueryParametersObject.js'
import { useDidomiEcommerceEvent } from '../../../../hooks/useDidomiDataLayer.js'
import useThemeFeatures from '../../../../hooks/useThemeFeatures.js'
import ModalHandler from '../../../../providers/Modal/ModalHandler.jsx'
import resetScroll from '../../../../services/resetScroll'
import TimeSort from '../../../../services/Sorting/TimeSort'
import { clearSchoolOptions } from '../../../../store/cart/actions'
import { clearAllForms, removeFormEntry, setFormEntry } from '../../../../store/forms/actions'
import { goToStep, nextStep } from '../../../../store/stepsManagement/actions'
import { cancelSchoolRegistration, getKidsSchools } from '../../../kids/ecoleDeFoot/api'
import { cancelStageRegistration } from '../../../kids/stageDeFoot/api'
import schoolTrainingRegistration from '../../functions/schoolTrainingRegistration'
import NoSchoolTraining from './components/NoSchoolTraining/NoSchoolTraining'
import SlotChoicePreform from './components/SlotChoicePreform/SlotChoicePreform'
import SlotChoiceSlots from './components/SlotChoiceSlots/SlotChoiceSlots'

import './SlotChoice.scss'

export default function SlotChoice(props) {
    const user = useSelector(state => state.userLoaded)
    const currentStep = useSelector(state => state.stepManagement.currentStep)
    const ozmoSubscription = useSelector(state => state.forms.ozmoSubscription)
    const stepManagement = useSelector(state => state.stepManagement)
    const [currentPrivateCode, setCurrentPrivateCode] = useState('')
    const [codeError, setCodeError] = useState(false)
    const dispatch = useDispatch()

    const [isLoading, setIsLoading] = useState(false)
    const [slotsToDisplay, setSlotsToDisplay] = useState(null)

    const {
        value: {
            areas,
            availableSlots,
            selectedAreaCenters,
            isAdult,
            prestation,
            kidForm,
            selectedSlot,
            periodStart,
            centers,
            selectedKid,
            schoolSubscriptions,
            stageSubscriptions,
            isGlobalLoading,
            fromStep4,
            privateCode,
        },
        setValue: setCurrentSelection,
    } = useSchoolTrainingCurrent() || {}
    const { value: tunnelType } = useSchoolTrainingTunnel()
    const {
        value: { filterLevel, filterType, filterCenter },
        setValue: setCurrentFilter,
    } = useSchoolTrainingFilters()
    const { trackEcommerceEvent } = useDidomiEcommerceEvent()
    const themeFeatures = useThemeFeatures()
    const [, setSearchParams] = useSearchParams()
    const searchParamsObject = useQueryParametersObject()
    const apiCall = params => {
        selectedAreaCenters.forEach((id, i) => (params[`centersId[${i}]`] = id))
        setIsLoading(true)
        const getFunction =
            tunnelType === 'SCHOOL' ? getKidsSchools : tunnelType === 'TRAINING' ? getKidsStages : undefined
        getFunction?.(params)
            .then(res => {
                const sessions = res?.sessions?.map(session => ({ ...session, tunnelType }))
                const selectedKidAge =
                    kidForm?.birthDate &&
                    Math.floor((new Date() - new Date(kidForm?.birthDate)) / (1000 * 60 * 60 * 24 * 365))
                const filteredSlots = sessions.filter(slot => {
                    const target = tunnelType === 'SCHOOL' ? slot.schoolDetails : slot
                    const { minAge, maxAge } = target
                    if (
                        filterLevel &&
                        ((target?.maxLevel && target?.maxLevel < filterLevel) ||
                            (target?.minLevel && target?.minLevel > filterLevel))
                    ) {
                        return false
                    } else if (
                        filterType !== null &&
                        ((filterType === 1 && target.individualCollective === 0) ||
                            (filterType !== 1 && target?.individualCollective !== filterType))
                    ) {
                        return false
                    } else if (filterCenter && target?.centerId !== filterCenter) {
                        return false
                    } else if (
                        selectedKidAge &&
                        ((minAge && selectedKidAge < minAge) || (maxAge && selectedKidAge > maxAge))
                    ) {
                        return false
                    } else {
                        return true
                    }
                })
                if (tunnelType === 'SCHOOL') {
                    filteredSlots?.sort(TimeSort.sortByAscSchoolStart)
                }

                // If using private code and slot is found, automatically select it
                if (params.privateCode && filteredSlots?.length === 1) {
                    const slot = filteredSlots[0]
                    const slotDetails = slot.schoolDetails
                    const slotCenterId = slot.schoolDetails?.centerId ?? slot.centerId
                    const slotArea = areas.find(area => area?.centers?.find(center => center === slotCenterId))

                    const defaultValues = prev => ({
                        ...prev,
                        adultForm: {
                            birthdate: user?.birthdate ? new Date(user.birthdate) : '',
                            level: user?.playerProfile?.level ?? '',
                            ranking: user?.playerProfile?.ranking ?? '',
                            title: user?.title ?? '',
                        },
                        kidForm: {
                            birthDate: '',
                            firstname: '',
                            gender: '',
                            lastname: '',
                        },
                        privateCode: 'reset',
                        selectedKid: undefined,
                    })

                    if (slotDetails.ageCategory === 1 && !isAdult) {
                        // reset and redirect to previous step, used a code that is for adult
                        dispatch(goToStep(0))
                        ModalHandler.show(MessagePopin, {
                            message:
                                'Le code privé que vous avez renseigné est réservé aux adultes. Merci de vérifier votre saisie.',
                            title: 'Code privé invalide',
                        })
                        setCurrentSelection(prev =>
                            defaultValues({
                                ...prev,
                                availableSlots: [],
                                isAdult: true,
                            }),
                        )
                        setIsLoading(false)
                        setCurrentPrivateCode('')
                        return
                    } else if (slotDetails.ageCategory === 0 && isAdult) {
                        // reset and redirect to previous step, used a code that is for child
                        dispatch(goToStep(0))
                        ModalHandler.show(MessagePopin, {
                            message:
                                'Le code privé que vous avez renseigné est réservé aux enfants. Merci de vérifier votre saisie.',
                            title: 'Code privé invalide',
                        })
                        setCurrentSelection(prev =>
                            defaultValues({
                                ...prev,
                                availableSlots: [],
                                isAdult: false,
                            }),
                        )
                        setIsLoading(false)
                        setCurrentPrivateCode('')
                        return
                    }

                    setCurrentSelection(prev => ({
                        ...prev,
                        privateCode: params.privateCode,
                        selectedAreaCenters: slotArea.centers,
                        selectedAreaId: slotArea.id,
                    }))

                    setTimeout(() => {
                        setCurrentSelection(prev => ({
                            ...prev,
                            availableSlots: filteredSlots,
                            selectedSlot: filteredSlots[0],
                        }))
                    }, 0)
                } else {
                    setCurrentSelection(prev => ({ ...prev, availableSlots: filteredSlots, privateCode: null }))
                }

                if (params.privateCode) {
                    setCurrentPrivateCode(params.privateCode)

                    setCodeError(false)
                }
                setIsLoading(false)
            })
            .catch(() => {
                setIsLoading(false)
                setCurrentSelection(prev => ({ ...prev, availableSlots: [] }))
                if (params.privateCode) {
                    delete params.privateCode
                    apiCall(params)
                    setCodeError(true)
                }
            })
    }

    const slotChoiceRef = useRef(null)

    const setFormInStore = (name, data) => {
        dispatch(setFormEntry(name, data))
    }
    const removeFormInStore = name => {
        dispatch(removeFormEntry(name))
    }

    const filterSubscribed = subs =>
        subs.filter(
            sub =>
                !!(
                    (isAdult &&
                        ((tunnelType === 'SCHOOL' && sub.school.id === selectedSlot.value) ||
                            (tunnelType === 'TRAINING' && sub.id === selectedSlot.id))) ||
                    (!isAdult &&
                        ((tunnelType === 'SCHOOL' &&
                            sub.school.id === selectedSlot.value &&
                            sub.kid?.id === selectedKid?.id) ||
                            (tunnelType === 'TRAINING' &&
                                sub.training?.id === selectedSlot.id &&
                                sub.kid?.id === selectedKid?.id)))
                ),
        )

    const filterSLots = slots => {
        return slots.filter(slot => {
            const target = tunnelType === 'SCHOOL' ? slot.schoolDetails : slot

            if (
                filterLevel &&
                ((target?.maxLevel && target?.maxLevel < filterLevel) ||
                    (target?.minLevel && target?.minLevel > filterLevel))
            ) {
                return false
            } else if (
                filterType !== null &&
                ((filterType === 1 && target.individualCollective === 0) ||
                    (filterType !== 1 && target?.individualCollective !== filterType))
            ) {
                return false
            } else {
                return !(filterCenter && target?.centerId !== filterCenter)
            }
        })
    }

    useEffect(() => {
        setFormInStore('choixEnfant', selectedKid)
    }, [selectedKid])

    useEffect(() => {
        if (apiCall && selectedAreaCenters && prestation && currentStep === 2 && !fromStep4) {
            setSlotsToDisplay([])
            setCurrentSelection(prev => ({ ...prev, availableSlots: null }))
            const params = {
                [tunnelType === 'SCHOOL' ? 'schoolType' : 'stageType']: prestation?.value,
                ageCategory: isAdult ? 1 : 0,
                kidBirthYear: kidForm?.birthDate?.split('-')?.[0],
                orderByAsc: true,
                periodStart: dayjs(periodStart).format('YYYY-MM-DD'),
            }
            selectedAreaCenters.forEach((id, i) => (params[`centersId[${i}]`] = id))
            Object.keys(params).forEach(
                param =>
                    (params[param] === null || params[param] === undefined || params[param] === '') &&
                    delete params[param],
            )
            apiCall(params)
        } else if (fromStep4) {
            resetScroll()
            setCurrentSelection(prev => ({ ...prev, fromStep4: false }))
            if (ozmoSubscription?.firstSubscription?.id) {
                const api = tunnelType === 'SCHOOL' ? cancelSchoolRegistration : cancelStageRegistration
                api(ozmoSubscription.firstSubscription.id)
                dispatch(clearAllForms())
                dispatch(clearSchoolOptions())
            }
        }
    }, [selectedAreaCenters, isAdult, prestation, kidForm, currentStep, periodStart])

    useEffect(() => {
        if (selectedSlot && !selectedSlot.schoolDetails?.full && !selectedSlot.full) {
            slotChoiceRef?.current?.validate()
        } else {
            slotChoiceRef?.current?.unvalidate()
        }
    }, [selectedSlot])

    useEffect(() => {
        if (availableSlots) {
            const filteredSlots = filterSLots(availableSlots)

            if (
                selectedSlot &&
                !filteredSlots?.some(
                    slot =>
                        (tunnelType === 'TRAINING' && slot.id === selectedSlot.id) ||
                        (tunnelType === 'SCHOOL' && slot.value === selectedSlot.value),
                )
            ) {
                setCurrentSelection(prev => ({ ...prev, selectedSlot: undefined }))
            }
            setSlotsToDisplay(filteredSlots)
            resetScroll()
        }
    }, [availableSlots, filterLevel, filterType, filterCenter])

    const checkSkipStep = () =>
        (selectedSlot?.schoolDetails?.optionProducts ?? []).every(option => option.showAtPayment === true) &&
        (filterSLots(availableSlots).filter(
            el => el.value !== selectedSlot?.value && el.schoolDetails?.promotedForSecondRegistration,
        ).length ||
            !selectedSlot?.schoolDetails?.discount)

    return (
        <Step
            {...props}
            title={tunnelType === 'SCHOOL' ? 'Choix du créneau' : 'Choix du stage'}
            help={<PhoneCallHelp />}
            helpId={'HTMLSpanElementHelp'}
            className='slotChoice'
            returnText={<span className='customText'>Précédent</span>}
            nextText={<span className='customText'>Suivant</span>}
            checkBeforeNextStep={() => {
                const skipPrestaSup = checkSkipStep()

                setCurrentSelection(prev => ({ ...prev, fromStep4: true, skipPrestaSup }))

                schoolTrainingRegistration(
                    user,
                    selectedKid,
                    selectedSlot,
                    tunnelType,
                    setFormInStore,
                    removeFormInStore,
                    setIsLoading,
                    () => (skipPrestaSup ? dispatch(goToStep(stepManagement.currentStep + 2)) : dispatch(nextStep())),
                    slotsToDisplay,
                    filterSubscribed(tunnelType === 'SCHOOL' ? schoolSubscriptions : stageSubscriptions),
                    isAdult,
                    trackEcommerceEvent,
                    themeFeatures,
                    id => {
                        setSearchParams({
                            ...searchParamsObject,
                            firstSub: id,
                        })
                    },
                )
            }}
            onReturn={() => {
                setCurrentPrivateCode('')
                setCurrentSelection(prev => ({ ...prev, privateCode: null }))
            }}
            ref={slotChoiceRef}
        >
            {(isLoading || isGlobalLoading) && <Preloader fixed />}
            <SlotChoicePreform
                onPrivateCodeChange={code => {
                    const params = {
                        [tunnelType === 'SCHOOL' ? 'schoolType' : 'stageType']: prestation?.value,
                        ageCategory: isAdult ? 1 : 0,
                        kidBirthYear: kidForm?.birthDate?.split('-')?.[0],
                        orderByAsc: true,
                        periodStart: dayjs(periodStart).format('YYYY-MM-DD'),
                    }

                    if (currentPrivateCode || privateCode) {
                        setCurrentPrivateCode('')
                        setCodeError(false)
                        apiCall({ ...params })
                        return
                    }
                    selectedAreaCenters.forEach((id, i) => (params[`centersId[${i}]`] = id))
                    apiCall({ ...params, privateCode: code })
                }}
                currentPrivateCode={currentPrivateCode || privateCode}
                codeError={codeError}
            />
            {(filterLevel || filterType !== null || filterCenter !== null) && (
                <ActiveFilters>
                    {filterLevel && (
                        <CheckBlock
                            checked
                            unselect
                            action={() => {
                                setCurrentFilter(prev => ({ ...prev, filterLevel: null }))
                            }}
                        >
                            {`Niveau ${filterLevel}`}
                        </CheckBlock>
                    )}
                    {filterType !== null && (
                        <CheckBlock
                            checked
                            unselect
                            action={() => {
                                setCurrentFilter(prev => ({ ...prev, filterType: null }))
                            }}
                        >
                            {filterType === 0 ? 'Individuel' : 'Collectif'}
                        </CheckBlock>
                    )}
                    {filterCenter !== null && (
                        <CheckBlock
                            checked
                            unselect
                            action={() => {
                                setCurrentFilter(prev => ({
                                    ...prev,
                                    filterCenter: null,
                                    filterLevel: filterLevel,
                                    filterType: filterType,
                                }))
                            }}
                        >
                            {centers?.find(center => center.key === filterCenter)?.value}
                        </CheckBlock>
                    )}
                </ActiveFilters>
            )}
            {!isLoading && slotsToDisplay?.length === 0 && <NoSchoolTraining />}
            <SlotChoiceSlots slots={slotsToDisplay} />
        </Step>
    )
}
